import React, { useState } from 'react';
import Modal from './modal';
import DocumentViewer from './document-viewer';

type Props = {
  documents: Array<{ title: string; url: string }>;
  activeIndex: number;
  onChange?: (index: number) => void;
};

const DocumentViewerModal = ({ documents, activeIndex, onChange }: Props) => {
  const [autoSize, setAutoSize] = useState(true);
  function setResized({ height }) {
    if (height > 0) {
      setAutoSize(false);
    }
  }
  if (activeIndex !== undefined) {
    return (
      <Modal
        autoSize={autoSize}
        onClose={() => onChange?.(undefined)}
        key={documents[activeIndex].url}
      >
        <DocumentViewer
          documents={documents}
          activeIndex={activeIndex}
          scrolling={autoSize}
          onResized={setResized}
          onChange={onChange}
        />
      </Modal>
    );
  }

  return null;
};

export default DocumentViewerModal;
